module.exports = __webpack_public_path__ + "static/media/position-is-closed-.3979f69c.png";